
interface I_History {
    CreateDateTime: string | undefined;
    Source: string | undefined;
    Name: string | undefined;
    ProductID: string | undefined;
    Url: string | undefined;
    Price: string | undefined;
    DepartureDate: string | undefined;
}

declare global {
    interface Window {
        Print: any;
    }
}

export const SideBar = (togglePrintLbx: { (isOpen: any): void; (arg0: boolean): void }) => {
    //列印
    window.Print = () => {
        togglePrintLbx(true);
    };

    //看過
    const VisitHistory = localStorage.getItem('VisitHistory');
    const historyList = !localStorage.getItem('VisitHistory')
        ? new Array()
        : VisitHistory && JSON.parse(VisitHistory);

    const AddVisitHistory = (history: I_History) => {
        if (!history) return;
        if (!history.CreateDateTime) return;
        if (!history.Source) return;
        if (!history.Name) return;
        if (!history.Url) return;
        if (!history.Price) return;
        if (!history.DepartureDate) return;
        //若都有資料則加入到List中
        historyList.push(history);
        localStorage.setItem('VisitHistory', JSON.stringify(historyList));
    };

    const IsInVisitHistory = (productID: string | undefined) => {
        let isInVisitHistory = false;
        for (const key in historyList) {
            if (historyList[key].ProductID == productID) {
                isInVisitHistory = true;
                break;
            }
        }
        return isInVisitHistory;
    };

    const {
        createdatetime,
        traveltype,
        tourname,
        groupid,
        price,
        departuredate,
    } = document.getElementById('visitPara')!.dataset!;

    const ToSetVisitPara = {
        CreateDateTime: createdatetime,
        Source: traveltype,
        Name: tourname,
        ProductID: groupid,
        Url: location.href,
        Price: price,
        DepartureDate: departuredate,
    };

    if (!IsInVisitHistory(groupid)) {
        AddVisitHistory(ToSetVisitPara);
    }
};
